import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

export default function ImageUpload({ onUploaded, testid = "image-upload" }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onUploaded(data.url);
      toast.success("Image téléversée");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid={`${testid}-input`} />
      <button type="button" onClick={() => inputRef.current?.click()} disabled={loading} data-testid={testid}
        className="flex items-center gap-2 rounded-lg border border-orange-500/40 px-3 py-2 text-xs font-bold uppercase tracking-wider text-orange-400 transition-all hover:scale-[1.02] hover:bg-orange-500/10 disabled:opacity-50">
        <Upload className="h-4 w-4" /> {loading ? "Envoi..." : "Téléverser"}
      </button>
    </>
  );
}
